var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "border-card" },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "Report Types", name: "types" } },
            [
              _c(
                "div",
                { staticClass: "button-container" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.handleCreateType()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-plus" }),
                      _vm._v(" Add Report Type "),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.typesLoading,
                      expression: "typesLoading",
                    },
                  ],
                  attrs: {
                    data: _vm.reportTypes,
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "ID", width: "60", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [_vm._v(_vm._s(row.id))]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Name", width: "250" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              { attrs: { type: "primary", size: "small" } },
                              [_vm._v(_vm._s(row.name))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Display Name" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [_vm._v(_vm._s(row.displayName))]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Period", width: "100", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type:
                                    row.periodType === "daily"
                                      ? ""
                                      : row.periodType === "weekly"
                                      ? "warning"
                                      : "success",
                                  size: "small",
                                },
                              },
                              [_vm._v(" " + _vm._s(row.periodType) + " ")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Cron", width: "130", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            row.scheduleCron
                              ? _c(
                                  "el-tag",
                                  { attrs: { size: "small", type: "info" } },
                                  [_vm._v(_vm._s(row.scheduleCron))]
                                )
                              : _c("span", [_vm._v("-")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Last Run", width: "170", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  row.lastRunAt
                                    ? _vm.formatDate(row.lastRunAt)
                                    : "Never"
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Status", width: "100", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: row.isActive ? "success" : "danger",
                                  size: "small",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      row.isActive ? "Active" : "Inactive"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Actions", width: "220", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleUpdateType(row)
                                  },
                                },
                              },
                              [_vm._v("Edit")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: "warning",
                                  loading: _vm.triggerLoading === row.id,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleTriggerReport(row)
                                  },
                                },
                              },
                              [_vm._v("Run")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "danger" },
                                on: {
                                  click: function ($event) {
                                    return _vm.showDeleteType(row)
                                  },
                                },
                              },
                              [_vm._v("Delete")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title:
                      _vm.typeDialogStatus === "create"
                        ? "Create Report Type"
                        : "Edit Report Type",
                    visible: _vm.typeDialogVisible,
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.typeDialogVisible = $event
                    },
                  },
                },
                [
                  _c(
                    "el-form",
                    {
                      ref: "typeForm",
                      staticStyle: { width: "500px", "margin-left": "50px" },
                      attrs: {
                        model: _vm.tempType,
                        rules: _vm.typeRules,
                        "label-width": "150px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Name", prop: "name" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "e.g. subscription_daily_audit",
                              disabled: _vm.typeDialogStatus === "update",
                            },
                            model: {
                              value: _vm.tempType.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.tempType, "name", $$v)
                              },
                              expression: "tempType.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "Display Name", prop: "displayName" },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "e.g. Subscription Daily Audit",
                            },
                            model: {
                              value: _vm.tempType.displayName,
                              callback: function ($$v) {
                                _vm.$set(_vm.tempType, "displayName", $$v)
                              },
                              expression: "tempType.displayName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Description" } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", rows: 3 },
                            model: {
                              value: _vm.tempType.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.tempType, "description", $$v)
                              },
                              expression: "tempType.description",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Period Type" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.tempType.periodType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.tempType, "periodType", $$v)
                                },
                                expression: "tempType.periodType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "Daily", value: "daily" },
                              }),
                              _c("el-option", {
                                attrs: { label: "Weekly", value: "weekly" },
                              }),
                              _c("el-option", {
                                attrs: { label: "Monthly", value: "monthly" },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                color: "#909399",
                              },
                            },
                            [
                              _vm._v(
                                " Daily: yesterday, Weekly: Mon-Sun, Monthly: full previous month "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Cron Schedule" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "e.g. 0 7 * * *" },
                            model: {
                              value: _vm.tempType.scheduleCron,
                              callback: function ($$v) {
                                _vm.$set(_vm.tempType, "scheduleCron", $$v)
                              },
                              expression: "tempType.scheduleCron",
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                color: "#909399",
                              },
                            },
                            [
                              _vm._v(
                                " Daily: 0 7 * * * | Weekly (Sun): 59 23 * * 0 | Monthly (1st): 0 7 1 * * "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Active" } },
                        [
                          _c("el-switch", {
                            model: {
                              value: _vm.tempType.isActive,
                              callback: function ($$v) {
                                _vm.$set(_vm.tempType, "isActive", $$v)
                              },
                              expression: "tempType.isActive",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { attrs: { slot: "footer" }, slot: "footer" },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.typeDialogVisible = false
                            },
                          },
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.typeDialogStatus === "create"
                                ? _vm.createType()
                                : _vm.updateType()
                            },
                          },
                        },
                        [_vm._v("Confirm")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "Delete Report Type",
                    visible: _vm.deleteTypeVisible,
                    width: "30%",
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.deleteTypeVisible = $event
                    },
                  },
                },
                [
                  _c("span", [
                    _vm._v("Are you sure you want to delete this report type?"),
                  ]),
                  _c(
                    "span",
                    { attrs: { slot: "footer" }, slot: "footer" },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.deleteTypeVisible = false
                            },
                          },
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger" },
                          on: {
                            click: function ($event) {
                              return _vm.deleteType()
                            },
                          },
                        },
                        [_vm._v("Delete")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "Recipient Groups", name: "groups" } },
            [
              _c(
                "div",
                { staticClass: "button-container" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.handleCreateGroup()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-plus" }),
                      _vm._v(" Add Group "),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.groupsLoading,
                      expression: "groupsLoading",
                    },
                  ],
                  attrs: {
                    data: _vm.recipientGroups,
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "ID", width: "60", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [_vm._v(_vm._s(row.id))]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Group Name", width: "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [_c("strong", [_vm._v(_vm._s(row.name))])]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Description" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [_vm._v(_vm._s(row.description || "-"))]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Recipients",
                      width: "110",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              { attrs: { type: "primary", size: "small" } },
                              [_vm._v(_vm._s((row.recipients || []).length))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Status", width: "100", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: row.isActive ? "success" : "danger",
                                  size: "small",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      row.isActive ? "Active" : "Inactive"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Actions", width: "250", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleUpdateGroup(row)
                                  },
                                },
                              },
                              [_vm._v("Edit")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "success" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleAddRecipient(row)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "el-icon-plus" }),
                                _vm._v(" Recipient "),
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "danger" },
                                on: {
                                  click: function ($event) {
                                    return _vm.showDeleteGroup(row)
                                  },
                                },
                              },
                              [_vm._v("Delete")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { type: "expand" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-table",
                              {
                                staticStyle: { margin: "10px 0" },
                                attrs: {
                                  data: row.recipients || [],
                                  border: "",
                                  size: "small",
                                },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: { label: "Email", prop: "email" },
                                }),
                                _c("el-table-column", {
                                  attrs: { label: "Name", width: "200" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _vm._v(
                                              _vm._s(scope.row.name || "-")
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "Status",
                                    width: "100",
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-tag",
                                              {
                                                attrs: {
                                                  type: scope.row.isActive
                                                    ? "success"
                                                    : "danger",
                                                  size: "mini",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      scope.row.isActive
                                                        ? "Active"
                                                        : "Inactive"
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "Actions",
                                    width: "150",
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  size: "mini",
                                                  type: "primary",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleEditRecipient(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Edit")]
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  size: "mini",
                                                  type: "danger",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.removeRecipient(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Remove")]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title:
                      _vm.groupDialogStatus === "create"
                        ? "Create Group"
                        : "Edit Group",
                    visible: _vm.groupDialogVisible,
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.groupDialogVisible = $event
                    },
                  },
                },
                [
                  _c(
                    "el-form",
                    {
                      ref: "groupForm",
                      staticStyle: { width: "450px", "margin-left": "50px" },
                      attrs: {
                        model: _vm.tempGroup,
                        rules: _vm.groupRules,
                        "label-width": "120px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Name", prop: "name" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "e.g. Engineering Team" },
                            model: {
                              value: _vm.tempGroup.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.tempGroup, "name", $$v)
                              },
                              expression: "tempGroup.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Description" } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", rows: 3 },
                            model: {
                              value: _vm.tempGroup.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.tempGroup, "description", $$v)
                              },
                              expression: "tempGroup.description",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Active" } },
                        [
                          _c("el-switch", {
                            model: {
                              value: _vm.tempGroup.isActive,
                              callback: function ($$v) {
                                _vm.$set(_vm.tempGroup, "isActive", $$v)
                              },
                              expression: "tempGroup.isActive",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { attrs: { slot: "footer" }, slot: "footer" },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.groupDialogVisible = false
                            },
                          },
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.groupDialogStatus === "create"
                                ? _vm.createGroup()
                                : _vm.updateGroup()
                            },
                          },
                        },
                        [_vm._v("Confirm")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "Delete Group",
                    visible: _vm.deleteGroupVisible,
                    width: "30%",
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.deleteGroupVisible = $event
                    },
                  },
                },
                [
                  _c("span", [
                    _vm._v(
                      "Are you sure? All recipients in this group will also be deleted."
                    ),
                  ]),
                  _c(
                    "span",
                    { attrs: { slot: "footer" }, slot: "footer" },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.deleteGroupVisible = false
                            },
                          },
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger" },
                          on: {
                            click: function ($event) {
                              return _vm.deleteGroup()
                            },
                          },
                        },
                        [_vm._v("Delete")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title:
                      _vm.recipientDialogStatus === "create"
                        ? "Add Recipient"
                        : "Edit Recipient",
                    visible: _vm.recipientDialogVisible,
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.recipientDialogVisible = $event
                    },
                  },
                },
                [
                  _c(
                    "el-form",
                    {
                      ref: "recipientForm",
                      staticStyle: { width: "450px", "margin-left": "50px" },
                      attrs: {
                        model: _vm.tempRecipient,
                        rules: _vm.recipientRules,
                        "label-width": "120px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Email", prop: "email" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "user@example.com" },
                            model: {
                              value: _vm.tempRecipient.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.tempRecipient, "email", $$v)
                              },
                              expression: "tempRecipient.email",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Name" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "John Doe" },
                            model: {
                              value: _vm.tempRecipient.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.tempRecipient, "name", $$v)
                              },
                              expression: "tempRecipient.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Active" } },
                        [
                          _c("el-switch", {
                            model: {
                              value: _vm.tempRecipient.isActive,
                              callback: function ($$v) {
                                _vm.$set(_vm.tempRecipient, "isActive", $$v)
                              },
                              expression: "tempRecipient.isActive",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { attrs: { slot: "footer" }, slot: "footer" },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.recipientDialogVisible = false
                            },
                          },
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.recipientDialogStatus === "create"
                                ? _vm.createRecipient()
                                : _vm.updateRecipient()
                            },
                          },
                        },
                        [_vm._v("Confirm")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "Assignments", name: "assignments" } },
            [
              _c(
                "div",
                {
                  staticClass: "button-container",
                  staticStyle: {
                    display: "flex",
                    gap: "12px",
                    "align-items": "center",
                    "flex-wrap": "wrap",
                  },
                },
                [
                  _c("span", [_vm._v("Report Type:")]),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "300px" },
                      attrs: { placeholder: "Select report type" },
                      on: { change: _vm.fetchAssignments },
                      model: {
                        value: _vm.selectedTypeId,
                        callback: function ($$v) {
                          _vm.selectedTypeId = $$v
                        },
                        expression: "selectedTypeId",
                      },
                    },
                    _vm._l(_vm.reportTypes, function (t) {
                      return _c("el-option", {
                        key: t.id,
                        attrs: { label: t.displayName, value: t.id },
                      })
                    }),
                    1
                  ),
                  _vm.availableGroups.length > 0
                    ? _c(
                        "el-select",
                        {
                          staticStyle: { width: "250px" },
                          attrs: { placeholder: "Assign a group..." },
                          on: { change: _vm.handleAssignGroup },
                          model: {
                            value: _vm.assignGroupId,
                            callback: function ($$v) {
                              _vm.assignGroupId = $$v
                            },
                            expression: "assignGroupId",
                          },
                        },
                        _vm._l(_vm.availableGroups, function (g) {
                          return _c("el-option", {
                            key: g.id,
                            attrs: { label: g.name, value: g.id },
                          })
                        }),
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "warning",
                        size: "small",
                        disabled:
                          !_vm.selectedTypeId || _vm.assignments.length === 0,
                        loading: _vm.testSendLoading,
                      },
                      on: { click: _vm.handleTestSend },
                    },
                    [
                      _c("i", { staticClass: "el-icon-s-promotion" }),
                      _vm._v(" Test Send "),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.assignmentsLoading,
                      expression: "assignmentsLoading",
                    },
                  ],
                  staticStyle: { "margin-top": "15px" },
                  attrs: {
                    data: _vm.assignments,
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "#", width: "60", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ $index }) {
                          return [_vm._v(_vm._s($index + 1))]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Group" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _vm._v(
                              _vm._s(
                                row.group
                                  ? row.group.name
                                  : "Group #" + row.groupId
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Description" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _vm._v(
                              _vm._s(row.group ? row.group.description : "-")
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Status", width: "100", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: row.isActive ? "success" : "danger",
                                  size: "small",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      row.isActive ? "Active" : "Inactive"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Actions", width: "100", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "danger" },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeAssignment(row)
                                  },
                                },
                              },
                              [_vm._v("Remove")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "Report Logs", name: "logs" } },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.logsLoading,
                      expression: "logsLoading",
                    },
                  ],
                  attrs: {
                    data: _vm.reportLogs,
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "ID",
                      width: "60",
                      align: "center",
                      prop: "id",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Report Type",
                      width: "110",
                      align: "center",
                      prop: "reportTypeId",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Status", width: "100", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type:
                                    row.status === "success"
                                      ? "success"
                                      : row.status === "partial"
                                      ? "warning"
                                      : "danger",
                                  size: "small",
                                },
                              },
                              [_vm._v(" " + _vm._s(row.status) + " ")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Recipients",
                      width: "100",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              { attrs: { type: "primary", size: "small" } },
                              [
                                _vm._v(
                                  _vm._s((row.recipientsJson || []).length)
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Duration", width: "100", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  row.durationMs != null
                                    ? (row.durationMs / 1000).toFixed(1) + "s"
                                    : "-"
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Started At",
                      width: "170",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [_vm._v(_vm._s(_vm.formatDate(row.startedAt)))]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Error" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            row.errorMessage
                              ? _c(
                                  "span",
                                  { staticStyle: { color: "#F56C6C" } },
                                  [_vm._v(_vm._s(row.errorMessage))]
                                )
                              : _c("span", [_vm._v("-")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "", width: "60", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("el-button", {
                              attrs: {
                                size: "mini",
                                type: "text",
                                icon: "el-icon-view",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.showLogDetail(row)
                                },
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { "text-align": "center", "margin-top": "20px" },
                },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.logsPage,
                      "page-size": _vm.logsPageSize,
                      total: _vm.logsTotal,
                      layout: "prev, pager, next",
                    },
                    on: { "current-change": _vm.handleLogsPageChange },
                  }),
                ],
                1
              ),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "Report Log Details",
                    visible: _vm.logDetailVisible,
                    width: "700px",
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.logDetailVisible = $event
                    },
                  },
                },
                [
                  _vm.selectedLog
                    ? [
                        _c(
                          "el-descriptions",
                          {
                            staticStyle: { "margin-bottom": "16px" },
                            attrs: { column: 2, border: "", size: "small" },
                          },
                          [
                            _c(
                              "el-descriptions-item",
                              { attrs: { label: "ID" } },
                              [_vm._v(_vm._s(_vm.selectedLog.id))]
                            ),
                            _c(
                              "el-descriptions-item",
                              { attrs: { label: "Status" } },
                              [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type:
                                        _vm.selectedLog.status === "success"
                                          ? "success"
                                          : _vm.selectedLog.status === "partial"
                                          ? "warning"
                                          : "danger",
                                      size: "small",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.selectedLog.status) + " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-descriptions-item",
                              { attrs: { label: "Started" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatDate(_vm.selectedLog.startedAt)
                                  )
                                ),
                              ]
                            ),
                            _c(
                              "el-descriptions-item",
                              { attrs: { label: "Completed" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.selectedLog.completedAt
                                      ? _vm.formatDate(
                                          _vm.selectedLog.completedAt
                                        )
                                      : "-"
                                  )
                                ),
                              ]
                            ),
                            _c(
                              "el-descriptions-item",
                              { attrs: { label: "Duration" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.selectedLog.durationMs != null
                                      ? (
                                          _vm.selectedLog.durationMs / 1000
                                        ).toFixed(1) + "s"
                                      : "-"
                                  )
                                ),
                              ]
                            ),
                            _c(
                              "el-descriptions-item",
                              { attrs: { label: "Recipients" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    (_vm.selectedLog.recipientsJson || [])
                                      .length
                                  )
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm.selectedLog.recipientsJson &&
                        _vm.selectedLog.recipientsJson.length
                          ? _c(
                              "div",
                              { staticStyle: { "margin-bottom": "16px" } },
                              [
                                _c("strong", [_vm._v("Recipients:")]),
                                _c(
                                  "div",
                                  { staticStyle: { "margin-top": "4px" } },
                                  _vm._l(
                                    _vm.selectedLog.recipientsJson,
                                    function (r, i) {
                                      return _c(
                                        "el-tag",
                                        {
                                          key: i,
                                          staticStyle: { margin: "2px 4px" },
                                          attrs: { size: "small" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                r.name
                                                  ? r.name +
                                                      " <" +
                                                      r.email +
                                                      ">"
                                                  : r.email
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.selectedLog.errorMessage
                          ? _c(
                              "div",
                              { staticStyle: { "margin-bottom": "16px" } },
                              [
                                _c("strong", [_vm._v("Error:")]),
                                _c(
                                  "pre",
                                  {
                                    staticStyle: {
                                      background: "#fef0f0",
                                      padding: "12px",
                                      "border-radius": "6px",
                                      "font-size": "12px",
                                      "white-space": "pre-wrap",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.selectedLog.errorMessage))]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.selectedLog.resultJson
                          ? _c("div", [
                              _c("strong", [_vm._v("Result Data:")]),
                              _c(
                                "pre",
                                {
                                  staticStyle: {
                                    background: "#f5f5f5",
                                    padding: "12px",
                                    "border-radius": "6px",
                                    "font-size": "12px",
                                    "max-height": "300px",
                                    overflow: "auto",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      JSON.stringify(
                                        _vm.selectedLog.resultJson,
                                        null,
                                        2
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }